<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex a-center py-2">
			<div class="d-flex a-center" style="width: 300px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">客户：</div>
				<el-select v-model="search.kh_id" filterable style="width: 50%;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-select v-model="search.kh_id" filterable style="width: 50%;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">仓库：</div>
				<el-select v-model="search.ck" filterable style="width: 90%;" size="mini" @change="currk">
				    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">库：</div>
				<el-select v-model="search.ck_k" filterable style="width: 90%;" size="mini" @change="currq">
				    <el-option v-for="item in ckk" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">区：</div>
				<el-select v-model="search.ck_q" filterable style="width: 90%;" size="mini" @change="currh">
				    <el-option v-for="item in ckq" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">列：</div>
				<el-select v-model="search.ck_h" filterable style="width: 90%;" size="mini" @change="currl">
				    <el-option v-for="item in ckh" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">层：</div>
				<el-select v-model="search.ck_l" filterable style="width: 90%;" size="mini" @change="currc">
				    <el-option v-for="item in ckl" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div class="d-flex a-center" style="width: 180px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">板：</div>
				<el-select v-model="search.ck_c" filterable style="width: 90%;" size="mini">
				    <el-option v-for="item in ckc" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div style="margin-left: auto;" class="d-flex a-center">
				<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
				<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
			</div>
		</div>
		<div>
			<el-table
				:data="kcmxList"
				style="width: 100%"
				size="mini"
				@selection-change="handleSelectionChange"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				 :max-height="maxHeight"
			>
				<el-table-column type="selection" width="50" align="center"></el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">
						编号
					</template>
					<template slot-scope="scope">
						{{ scope.row.bh }}
					</template>
				</el-table-column>
				<el-table-column width="80">
					<template slot="header" slot-scope="scope">
						货物名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column width="80">
					<template slot="header" slot-scope="scope">
						包装名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.kcmx.bzjf }}
					</template>
				</el-table-column>
				<el-table-column width="80">
					<template slot="header" slot-scope="scope">
						客户叫法
					</template>
					<template slot-scope="scope">
						{{ scope.row.kcmx.kc }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="270">
					<template slot="header" slot-scope="scope">
						仓库坐标
					</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{ scope.row.zbdata.wz }}</el-button>
					</template>
				</el-table-column>
				<el-table-column label="数量" align="center">
					<template slot-scope="scope">
						{{ scope.row.sl }}
					</template>
				</el-table-column>
				<el-table-column label="件数" align="center">
					<template slot-scope="scope">
						{{ scope.row.js }}
					</template>
				</el-table-column>
				<el-table-column label="体积" align="center">
					<template slot-scope="scope">
						{{ scope.row.tj }}
					</template>
				</el-table-column>
				<el-table-column label="面积" align="center">
					<template slot-scope="scope">
						{{ scope.row.mj }}
					</template>
				</el-table-column>
				<el-table-column label="入仓时间" width="180" align="center">
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="180">
					<template slot="header" slot-scope="scope">
						客户
					</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{ scope.row.khdata.name }}</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	components: {
		buttonSearch
	},
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				
			},
			search:{
				bh:'',
				kh_id: '',
				kstime: '',
				jstime: '',
				ck:'',
				ck_k:'',
				ck_q:'',
				ck_h:'',
				ck_l:'',
				zb:''
			},
			createModel: false,
			dialogType: 'kcmx',
			preUrl: 'bb/ckbb', //api
			kcmxList: [],
			maxHeight: 0,
			tjsl: 0,
			khlist:[],
			cklist:[],
			ckk:[],
			ckq:[],
			ckh:[],
			ckl:[],
			ckc:[]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
		
	},
	methods: {
		currk(val){
			this.axios.get('/admin/ckdjk?type='+this.search.ck, { token: true }).then(res => {
				this.ckk = res.data.data;
			});
		},
		currq(val){
			this.axios.get('/admin/ckdjq?type='+this.search.ck_k, { token: true }).then(res => {
				this.ckq = res.data.data;
			});
		},
		currh(val){
			this.axios.get('/admin/ckdjh?type='+this.search.ck_q, { token: true }).then(res => {
				this.ckh = res.data.data;
			});
		},
		currl(val){
			this.axios.get('/admin/ckdjl?type='+this.search.ck_h, { token: true }).then(res => {
				this.ckl = res.data.data;
			});
		},
		currc(val){
			this.axios.get('/admin/ckdjc?type='+this.search.ck_l, { token: true }).then(res => {
				this.ckc = res.data.data;
			});
		},
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&bh=${this.search.bh}&kh_id=${this.search.kh_id}&ck=${this.search.ck}&ck_k=${this.search.ck_k}&ck_q=${this.search.ck_q}&ck_h=${this.search.ck_h}&ck_l=${this.search.ck_l}&zb=${this.search.zb}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.kcmxList = e.list;
			// for (let a of e.list) {
			// 	this.tjsl += a.kcsl;
			// }
			// const h = this.$createElement;
			// this.$message({
			// 	showClose: true,
			// 	customClass:'ts',
			// 	duration: 5000,
			// 	message: h('p', null, [
			// 		h('span', { style: 'font-size: 18px' }, '统计信息 '), 
			// 		h('p', { style: 'font-size: 14px;color:#838383' }, '库存总量：' + this.tjsl)
			// 		]
			// 	)
			// });
			// console.log(this.tjsl);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'kcmx':
					this.form.kcmx = {
						id: item.id,
						mc: item.cpid.cpmc,
						ggbm: item.ggbm,
						rklj: item.rklj,
						cplx: item.cplx,
						cbj: item.cbj,
						cjr: item.cjr.name,
						cpbm: item.cpid.cpbm,
						dw: item.dw,
						create_time: item.create_time,
						update_time: item.update_time,
						scrq: item.scrq,
						bzq: item.cpid.bzqts,
						cpfl: item.cpfl,
						ckcw: item.ckcw.name,
						cklj: item.cklj,
						ggmc: item.ggmc,
						kcsl: item.kcsl
					};
					break;
			}
			this.createModel = true;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				bh:'',
				kh_id: '',
				kstime: '',
				jstime: '',
				ck:'',
				ck_k:'',
				ck_q:'',
				ck_h:'',
				ck_l:'',
				zb:''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.bh = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		
	}
};
</script>

<style>
	.ts{
		min-width: 200px;
		left:90%;
		background-color:#fff;
		box-shadow: 2px 2px 10px #cbcbcb;
	}
</style>
